import React, { useEffect, useReducer, useState } from 'react'
import { Button, Col, Container, Row, Spinner, Stack, Tab, Tabs } from 'react-bootstrap'
import DataTable from 'react-data-table-component'
import { IoIosArrowRoundDown } from "react-icons/io";
import axiosInstance from '../utils/axiosConfig';
import toast from 'react-hot-toast';
import moment from 'moment';
import _ from 'lodash'
import ReactDatePicker from 'react-datepicker';
import Select from 'react-select'
import { NotFound } from '../Components/NotFound';

function reducer(state, action) {
    switch (action.type) {
        case 'loading': {
            return {
                ...state,
                loader: action.loader
            }
        }
        case 'data': {
            return {
                ...state,
                data: action.data
            }
        }
        case 'filter': {
            return {
                ...state,
                filter: action.filter
            }
        }
        default:
            return state
    }
}

const options = [
    {
        value: 'entity_registration_data',
        label: 'Entity Registration Data',
        subType: [
            { value: 'entity_registered', label: 'entity registered' },
            { value: 'gstin_wise_entity_registered', label: 'gstin wise entity registered' },
            { value: 'entity_id_with_identifiers', label: 'entity id with identifiers' },
            { value: 'entity_ids_having_multiple_gstin', label: 'entity ids having multiple gstin' },
            { value: 'entity_ids_without_gstin', label: 'entity ids without gstin' },
            { value: 'entity_ids_without_pan', label: 'entity ids without pan and gstin' },
        ]
    },
    {
        value: 'invoice_data',
        label: 'Invoice Data',
        subType: [
            { value: 'invoices_registered', label: 'invoices registered' },
            { value: 'ledger_funded', label: 'ledger funded' },
            { value: 'invoices_funded_with_invoice_details', label: 'invoices funded with invoice details' },
            { value: 'invoices_cancelled', label: 'invoices cancelled' },
            { value: 'invoices_disbursed', label: 'invoices disbursed' },
            { value: 'ledger_with_partial_funding', label: 'ledger with partial funding' },
            { value: 'invoices_repaid', label: 'invoices repaid' },
            // { value: 'invoices_with_partial_funding', label: 'invoices with partial funding' },
            { value: 'funding_requests_rejected_for_reason_already_funded', label: 'funding requests rejected for reason already funded' }
        ]
    }
]


export const UserMis = () => {
    const [state, dispatch] = useReducer(reducer, {
        data: {},
        loader: false,
        filter: {
            fromDate: moment().subtract(1, 'M').format('DD/MM/YYYY'),
            toDate: moment().format('DD/MM/YYYY'),
            // idpId: {},
            reportType: options[0],
            reportSubType: options[0].subType[0]
        }
    })

    const sortIcon = <IoIosArrowRoundDown className='text-dark' />
    const paginationComponentOptions = {
        noRowsPerPage: true,
    }
    const [tableCol, setTableCol] = useState([]);
    // const [idpidOptions, setIdpidOptions] = useState([])
    const [loggedInIdpId, setLoggedInIdpId] = useState(null);

    useEffect(() => {
        const misUserIdpId = localStorage.getItem("misUserIdpId");
        if (misUserIdpId) {
            setLoggedInIdpId(misUserIdpId);
        }
    }, []);
    
    useEffect(() => {
        if (loggedInIdpId) {
            fetchData({
                ...state.filter,
                idpId: [loggedInIdpId],
                reportType: state.filter.reportType.value,
                reportSubType: state.filter.reportSubType.value
            });
        }
    }, [loggedInIdpId]);  // Run when `loggedInIdpId` updates
    




    const fetchData = (filter) => {
        dispatch({
            type: 'loading',
            loader: true
        })
        axiosInstance().post(
            'portal-api/get-user-mis-report', filter
        ).then((res) => {
            if ([200].includes(res.data?.code)) {
                dispatch({
                    type: 'loading',
                    loader: false
                })
                dispatch({
                    type: 'data',
                    data: res.data.data
                })
                setTableCol(Object.keys(res.data.data.length > 0 ? res.data.data[0] : {}).map(key => ({
                    name: _.startCase(_.camelCase(key)),
                    selector: row => row[key],
                    sortable: true,
                })))
            } else {
                toast.error(res.data?.message)
                dispatch({
                    type: 'loading',
                    loader: false
                })
            }
        }).catch(err => {
            toast.error(err.toString())
            console.log(err)
            dispatch({
                type: 'loading',
                loader: false
            })
        })
        toast.dismiss()
    }

    const download = () => {
        toast.promise(
            axiosInstance().post(
                'portal-api/download-user-mis-report',
                {
                    ...state.filter,
                    idpId: [loggedInIdpId],
                    reportType: state.filter.reportType.value,
                    reportSubType: state.filter.reportSubType.value
                },
                {
                    responseType: 'blob', // important
                }
            ),
            {
                loading: 'Downloading...',
                success: (res) => {
                    // Extract filename from content-disposition header
                    const contentDisposition = res.headers['content-disposition'];
                    let downloadFilename = 'sample';
                    if (contentDisposition) {
                        const filenameMatch = contentDisposition.match(/filename="?(.+?)"?$/);
                        if (filenameMatch.length === 2) {
                            downloadFilename = filenameMatch[1];
                        }
                    }

                    console.log(res.data.type)
                    const href = window.URL.createObjectURL(res.data);
                    const link = document.createElement('a');
                    link.href = href;
                    link.setAttribute('download', downloadFilename); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    return 'Successfully Download'
                },
                error: (err) => <b>{err.toString()}</b>,
            }
        );
        toast.dismiss()
    }

    // useEffect(() => {
    //     axiosInstance().post(
    //         'api/getIdpList',
    //         {
    //             // gspUserId: "3"
    //         }
    //    ).then((res) => {
    //     if([200].includes(res.data?.code)) {
    //         let listOptions = _.filter(res.data.idpData.map((item) => ({
    //             value: item.idpCode.toString(),
    //             label: item.idpName
    //         })), function(o){
    //             return o.value !== '';
    //         })
    //         setIdpidOptions(listOptions)
    //         if(res.data.idpData.length > 0){
    //             dispatch({ type: 'filter', filter: {
    //                 ...state.filter,
    //                 idpId: listOptions[0]
    //             }})
    //             fetchData({ 
    //                 ...state.filter,
    //                 idpId: [listOptions[0].value],
    //                 reportType: state.filter.reportType.value,
    //                 reportSubType: state.filter.reportSubType.value
    //             })
    //         }
    //     } else {
    //         toast.error(res.data?.message)
    //     }
    //    }).catch(err => {
    //         toast.error(err.toString())
    //         console.log(err)
    //    })
    // }, [])

    return (
        <div className="home-container">
            <Container fluid className='h-100' style={{ margin: '10px 0' }}>
                <Stack gap={3}>
                    <Row className='shadow-sm bg-white sticky-top py-3 mb-2' style={{ zIndex: '1' }}>
                        <Col xs={10}>
                            <Stack direction="horizontal" gap={3}>
                                <ReactDatePicker
                                    showIcon
                                    value={state.filter.fromDate}
                                    selected={new Date(moment(state.filter.fromDate, 'DD/MM/YYYY'))}
                                    onChange={(date) => {
                                        dispatch({
                                            type: 'filter', filter: {
                                                ...state.filter,
                                                ...{ fromDate: moment(date).format('DD/MM/YYYY') }
                                            }
                                        })
                                    }}
                                    placeholderText="From Date"
                                    dateFormat="DD/MM/yy"
                                    name="fromDate"
                                    maxDate={new Date()}
                                    icon={<svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><rect width="18" height="18" x="3" y="4" rx="2" ry="2"></rect><line x1="16" x2="16" y1="2" y2="6"></line><line x1="8" x2="8" y1="2" y2="6"></line><line x1="3" x2="21" y1="10" y2="10"></line><path d="M8 14h.01"></path><path d="M12 14h.01"></path><path d="M16 14h.01"></path><path d="M8 18h.01"></path><path d="M12 18h.01"></path><path d="M16 18h.01"></path></svg>}
                                />
                                <ReactDatePicker
                                    showIcon
                                    maxDate={new Date()}
                                    minDate={new Date(moment(state.filter.fromDate, 'DD/MM/YYYY'))}
                                    selected={new Date(moment(state.filter.toDate, 'DD/MM/YYYY'))}
                                    value={state.filter.toDate}
                                    placeholderText="To Date"
                                    onChange={(date) => {
                                        dispatch({
                                            type: 'filter', filter: {
                                                ...state.filter,
                                                ...{ toDate: moment(date).format('DD/MM/YYYY') }
                                            }
                                        })
                                    }}
                                    dateFormat="DD/MM/yy"
                                    name="toDate"
                                    icon={<svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><rect width="18" height="18" x="3" y="4" rx="2" ry="2"></rect><line x1="16" x2="16" y1="2" y2="6"></line><line x1="8" x2="8" y1="2" y2="6"></line><line x1="3" x2="21" y1="10" y2="10"></line><path d="M8 14h.01"></path><path d="M12 14h.01"></path><path d="M16 14h.01"></path><path d="M8 18h.01"></path><path d="M12 18h.01"></path><path d="M16 18h.01"></path></svg>}
                                />
                                <Select
                                    defaultValue={state.filter.reportType}
                                    options={options}
                                    name='reportType'
                                    placeholder='Report Type'
                                    onChange={(value) => {
                                        dispatch({
                                            type: 'filter', filter: {
                                                ...state.filter,
                                                reportType: value,
                                                reportSubType: _.filter(options, { value: value.value })[0].subType[0]
                                            }
                                        })
                                    }}
                                />
                                <Select
                                    defaultValue={state.filter.reportSubType}
                                    options={_.filter(options, { value: state.filter.reportType.value })[0].subType}
                                    name='reportSubType'
                                    placeholder='Report Sub Type'
                                    onChange={(value) => {
                                        dispatch({
                                            type: 'filter', filter: {
                                                ...state.filter,
                                                reportSubType: value
                                            }
                                        })
                                    }}
                                    value={state.filter.reportSubType}
                                />
                                {/* <Select
                                    defaultValue={state.filter.idpId}
                                    options={idpidOptions}
                                    name='idpId'
                                    placeholder='IDP ID'
                                    onChange={(value) => dispatch({ type: 'filter', filter: {
                                        ...state.filter,
                                        idpId: value
                                    }})}
                                    isMulti={true}
                                    value={state.filter.idpId}
                                /> */}
                                <Button variant="primary" onClick={() => fetchData({
                                    ...state.filter,
                                    // idpId:  Array.isArray(state.filter.idpId) ? state.filter.idpId.map(item => item.value): [state.filter.idpId].map(item => item.value),
                                    idpId:[loggedInIdpId],
                                    reportType: state.filter.reportType.value,
                                    reportSubType: state.filter.reportSubType.value
                                })}>Apply</Button>
                            </Stack>
                        </Col>
                        <Col xs={2} className='d-flex justify-content-end'>
                            <Button variant="primary" onClick={() => download()}>Download</Button>
                        </Col>
                    </Row>
                    <div style={{ zIndex: 0 }}>
                        {
                            state.loader ? <div className='d-flex justify-content-center align-items-center mt-20' style={{ height: '100%' }}>
                                <Spinner animation="border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </Spinner>
                            </div> : tableCol.length <= 0 ?
                                <NotFound /> :
                                <DataTable
                                    columns={tableCol}
                                    data={state.data}
                                    sortIcon={sortIcon}
                                    highlightOnHover
                                    pagination
                                    paginationComponentOptions={paginationComponentOptions}
                                />
                        }
                    </div>
                </Stack>
            </Container>
        </div>
    )
}
